module.exports = __webpack_public_path__ + "img/d1.180789a2.webp";